import React from 'react';

import { SpecCourseLessonViewSectionDescription } from 'common.components/spec-course-lesson-view/__section-description/spec-course-lesson-view__section-description';
import { SpecCourseLessonViewSectionTitle } from 'common.components/spec-course-lesson-view/__section-title/spec-course-lesson-view__section-title';
import { SpecCourseLessonViewSection } from 'common.components/spec-course-lesson-view/__section/spec-course-lesson-view__section';

import './results__finished-no-students-stub.scss';

export const SpecCourseResultsFinishedNoStudentsStub = () => {
    return (
        <SpecCourseLessonViewSection mix="spec-course-results__finished-no-students-stub">
            <SpecCourseLessonViewSectionTitle id="specCourse.lessonView.resultsTable.noStudentsFinished.header" />
            <SpecCourseLessonViewSectionDescription id="specCourse.lessonView.resultsTable.noStudentsFinished.description" />
        </SpecCourseLessonViewSection>
    );
};
